module.exports = __webpack_public_path__ + "static/media/pizzaChampiñonesCebollaCaramelizada.0cdec97d.png";